import { axiosClient } from 'api/axiosClient';
import { useQuery, UseQueryOptions } from 'react-query';
import { DataEnvironment } from 'types/DataEnvironment';

const fetchDataEnvironments = async () => {
  const { data }: any = await axiosClient.get<DataEnvironment[]>(
    '/user_data_environments'
  );

  return data;
};

export const useDataEnvironments = (
  options?: UseQueryOptions<DataEnvironment[]>
) =>
  useQuery('dataEnvironments', fetchDataEnvironments, {
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    ...options,
  });
